import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['2,500 workouts = 2,500 decisions', 'Bundles you download and never fully open', 'You still search, pick and sequence every week', 'No plan for rain, small spaces or missing gear', 'Still eating your Sunday night'];
const withIt = ['One 45-minute session per class day, already decided', '52 weeks in 13 progressive blocks, deloads included', 'Swap tables by movement pattern for space, gear and weather', 'Beginner / Regular / Advanced written into every session', 'Print it, clip it to your clipboard, coach it'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-navy" data-id="element-253" data-mp="2954ihipammmc">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-254" data-mp="2d7hmo2oe6ch0">
        <div className="text-center" data-id="element-255" data-mp="30yn1qfmid0q9">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-256" data-mp="30xlgjibs2xut">
            Why this isn&apos;t another workout bundle
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-257" data-mp="1tf3ezxx9ud1k">
            A workout library vs{' '}
            <span className="text-crimson-deep" data-id="element-258" data-mp="23566tusnpkyb">a decided calendar</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-259" data-mp="236zg7hunmja0">
            Every bundle on the market sells you more options. Options were never
            the problem — deciding what to run on Wednesday at 6 a.m. was.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-navy-line" data-id="element-260" data-mp="2m40kf0gdwfcw">
          <div className="bg-navy-mid px-3.5 py-4 sm:p-6" data-id="element-261" data-mp="2h4xqab1xztjp">
            <h3 className="font-display text-base uppercase tracking-wide text-ink-soft sm:text-xl" data-id="element-262" data-mp="2h5qr6ve7zotx">
              A $197 workout bundle
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-263" data-mp="mrg0sihz8mm1">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-264" data-mp="2mtflkkroym0c">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-crimson/15" data-id="element-265" data-mp="2ru3n40djql8t">
                    <XIcon className="h-2.5 w-2.5 text-crimson-deep" aria-hidden="true" data-id="element-266" data-mp="30sp3bovjpo6f" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-gold/10 px-3.5 py-4 text-white sm:p-6" data-id="element-267" data-mp="3aql9s3djfuy7">
            <h3 className="font-display text-base uppercase tracking-wide text-gold sm:text-xl" data-id="element-268" data-mp="3aos1kjna12o3">
              The Decided Bootcamp
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-269" data-mp="3jidfk0rmafwg">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-270" data-mp="3ojaywgod5fzj">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-271" data-mp="7g5ezsi8verr">
                    <CheckIcon className="h-2.5 w-2.5 text-gold-hover" aria-hidden="true" data-id="element-272" data-mp="2gj0lfqojshd" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}